const ATTR_HIDDEN = 'hidden';
const CLASS_FADE_IN = 'fade-in';
const COOKIE_NAME = 'ab_container';
const PROPERTY_PREVIEW_VARIANT = 'previewVariant';

class ABTestContainer extends HTMLElement {

    constructor() {
        super();

        this.variantAElement = null;
        this.variantBElement = null;
        this.dimensionElement = null;

        this.activeVariant = null;
    }

    connectedCallback() {
        this.setElements();
        this.readActiveVariantFromCookie();
        this.showComponent();
    }

    setElements() {
        this.variantAElement = this.querySelector('div[data-variant="A"]');
        this.variantBElement = this.querySelector('div[data-variant="B"]');
        this.dimensionElement = this.querySelector('.abtest-dimension');

        this.allocationMap = JSON.parse(this.dataset.allocationMap);
    }

    readActiveVariantFromCookie() {
        if (this.dataset.hasOwnProperty(PROPERTY_PREVIEW_VARIANT)) {
            this.activeVariant = this.dataset[PROPERTY_PREVIEW_VARIANT];
            return;
        }
        const cookie = this.getCookie(COOKIE_NAME);
        if (cookie) {
            this.activeVariant = this.allocationMap[cookie];
        }
    }

    getCookie(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) {
            return parts.pop().split(';').shift();
        }
        return null;
    }

    showComponent() {
        const node = this.getShownNode();
        this.setPageview(node);
        this.lockHeight();

        if (node.dataset.hasOwnProperty("loadUrl")) {
            this.loadComponent(node);
        }

        this.changeVisibility(this.variantAElement, this.variantAElement === node);
        this.changeVisibility(this.variantBElement, this.variantBElement === node);
        this.unlockHeight();
    }

    setPageview(node) {
        const dimension = node.dataset.dimension;
        this.dimensionElement.innerHTML = `<dl-pageview ab-test="${dimension}"></dl-pageview>`;
    }

    getShownNode() {
        if (this.activeVariant === 'B') {
            return this.variantBElement;
        }
        return this.variantAElement;
    }

    lockHeight() {
        this.style.minHeight = this.offsetHeight + 'px';
    }

    unlockHeight() {
        setTimeout(() => {
            this.style.minHeight = '';
        }, 200);
    }

    loadComponent(node) {
        const url = node.dataset.loadUrl;
        fetch(url)
            .then(response => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response.text();
            })
            .then(body => {
                this.appendHtml(node, body);
            }).catch(() => {
            this.showDefaultFallback(node);
        });
    }

    showDefaultFallback(node) {
        this.changeVisibility(node, false);
        this.changeVisibility(this.variantAElement, true);
    }

    changeVisibility(node, visibility) {
        if (visibility) {
            node.classList.add(CLASS_FADE_IN);
            node.removeAttribute(ATTR_HIDDEN);
        } else {
            node.classList.remove(CLASS_FADE_IN);
            node.setAttribute(ATTR_HIDDEN, true);
        }
    }

    appendHtml(container, html) {
        const range = document.createRange();
        range.setStart(container, 0);
        range.setEnd(container, 0);
        container.appendChild(range.createContextualFragment(html));
    }

}

if (!customElements.get("abtest-container")) {
    customElements.define("abtest-container", ABTestContainer);
}
